// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"HamburgerMenu_hamburger__bqyWU","dropdownMenu":"HamburgerMenu_dropdownMenu__3AqV4"};